import { useCallback, useSyncExternalStore } from "react";

export type ResponsivePaneOptions = {
  inlineMinWidth: number;
};

export const usePanePresentation = (responsive?: ResponsivePaneOptions) => {
  const isResponsive = !!responsive;
  const inlineQuery = `(min-width: ${responsive?.inlineMinWidth ?? 0}px)`;
  const floatingQuery = "(min-width: 768px)";
  const subscribe = useCallback(
    (onChange: () => void) => {
      if (!isResponsive) return () => {};
      const queries = [inlineQuery, floatingQuery].map((query) =>
        window.matchMedia(query)
      );
      queries.forEach((query) => query.addEventListener("change", onChange));
      return () =>
        queries.forEach((query) =>
          query.removeEventListener("change", onChange)
        );
    },
    [inlineQuery, isResponsive]
  );

  return useSyncExternalStore<"inline" | "floating" | "fullscreen">(
    subscribe,
    () => {
      if (!isResponsive || window.matchMedia(inlineQuery).matches)
        return "inline";
      return window.matchMedia(floatingQuery).matches
        ? "floating"
        : "fullscreen";
    },
    () => "inline"
  );
};
